import {
    AppstoreOutlined,
    BookOutlined,
    DashboardOutlined,
    FileUnknownOutlined,
    ProfileOutlined,

} from '@ant-design/icons';

const dashboardNavTree = [
    {
        key: 'dashboard',
        title: 'home:sidenav.erp',
        icon: BookOutlined,
        breadcrumb: false,
        isGroupTitle: true,
        submenu: [
            {
                key: 'module-list',
                path: `dashboard/module-list`,
                title: 'home:dashboard.module_list',
                icon: AppstoreOutlined,
                breadcrumb: false,
                submenu: [],
            },{
                key: 'dashboard-general',
                path: `dashboard/general`,
                title: 'home:sidenav.dashboard',
                icon: DashboardOutlined,
                breadcrumb: false,
                submenu: [],
            },
        ]
    }
]

const docsNavTree = [
    {
        key: 'docs',
        title: 'home:sidenav.docs',
        icon: BookOutlined,
        breadcrumb: false,
        isGroupTitle: true,
        submenu: [
            {
                key: 'docs-documentation',
                path: `docs/documentation`,
                title: 'home:docs.documentation',
                icon: FileUnknownOutlined,
                breadcrumb: false,
                submenu: [],
            },
            {
                key: 'docs-changelog',
                path: `docs/changelog`,
                title: 'home:docs.changelog',
                icon: ProfileOutlined,
                breadcrumb: false,
                submenu: [],
            },
        ],
    },
];

const homeConfig = [...dashboardNavTree, ...docsNavTree];

export default homeConfig;